module.exports = __webpack_public_path__ + "static/media/CYB.35f643e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CYB.jpg
// module id = 1726
// module chunks = 1